import { marked } from "marked";

export const reactQuillmodules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline"],
    [{ align: [] }],
    ["blockquote", "code-block"],
  ],
};

export const reactQuillformats = [
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "header",
  "font",
  "align",
  "size",
  "color",
  "background",
  "code-block",
];

export const stripTableTagsWithSpace = (htmlString) => {
  if (htmlString != "") {
    return htmlString;
    const markedHtmlString = marked(htmlString);
    // console.log("36===>",markedHtmlString);
    return markedHtmlString
      .replace(/<\/?(table|thead|tbody)>/g, "") // Remove table tags
      .replace(/<\/?tr>/g, "<br>") // Add line breaks between rows
      .replace(/<\/?(th|td|strong)>/g, " ") // Add spaces between columns
      .replace(/\s+/g, " ") // Normalize spaces
      .trim();

    // return markedHtmlString
    // .replace(/<\/?(table|thead|tbody)>/g, "") // Remove table tags
    // .replace(/<\/?tr>/g, "<br>") // Add a line break between rows
    // .replace(/<\/?(th|td|strong)>/g, " ") // Add spaces between columns
    // .replace(/\s/g, "&nbsp;") // Replace all spaces with non-breaking spaces
    // .trim();
  }
  return "";
};
